import { makeSchoolQueryHttp } from '../../_shared/infrastructure/school-query.http';
import type { SchoolsGateway } from './schools.gateway';

/** Admin Schools list → the admin-wide, `requireAdmin`-guarded backend route. */
export const httpSchoolsGateway: SchoolsGateway = makeSchoolQueryHttp('/admin/schools');
